import router from '@/routes/router';
import { firebaseAuth } from '@/services/firebase/init';
import { errorHandler } from '@/utils/errors';

const state = {
  pwReset: false
};
const getters = {};

const actions = {
  logout(){
    firebaseAuth.signOut().then(() =>{
      router.replace('/admin/login');
    });
  },
  login({ commit }, { email, password }){
    commit('flipProcessing');
    firebaseAuth.signInWithEmailAndPassword(email, password).then(() =>{
      commit('flipProcessing');
      router.replace('/admin/home');
    }).catch(errorHandler).finally(()=>{commit('flipProcessing', false);});
  }
};
const mutations = {
  setPwReset(state, payload){
    state.payload = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
